<template>
  <div>
    <!-- -->
    <rabbey-table-3 :data="reportData" :columns="columns" :actions="[]">
    </rabbey-table-3>
  </div>
</template>

<script>
import { Columns } from "@/columns/DealRequiredActivitiesReport/DealRequiredActivitiesReportColumns";

export default {
  name: "ClientRabbeyDealsActivitiesRequiredReport",

  data() {
    return {
      columns: Columns,
      reportData: []
    };
  },

  mounted() {
    this.GetReport();
  },

  methods: {
    async GetReport() {
      await this.$http
        .get("/api/deals/RequiredActionReport")
        .then((response) => {
          this.reportData = response.data;
        })
        .catch((error) => {
          console.error("Error fetching report data:", error);
        });
    }
  }
};
</script>

<style scoped></style>
